/**
 * Where a thing lives in the address bar.
 *
 * ONUs are reachable three ways — the operator-facing NUMBER, the row id, and
 * the linked TR-069 device id — because links made before numbering existed
 * still have to land, and the API resolves all three. That tolerance is for
 * OLD links. It is not licence to keep making new ones: `/onus/25` is an
 * address somebody can read out over the phone, and
 * `/onus/olt_e16t27xwev27x7st` is a row id that leaked into a URL.
 *
 * So every place that builds an ONU link goes through here, and here prefers
 * the number. One helper rather than a rule in a comment, because the rule
 * written as a comment is the one the next link forgets.
 */
export function onuPath(onu: {
  number?: number | null;
  id?: string | null;
  deviceId?: string | null;
}): string {
  /*
    The number, when there is one. `number` is null only on rows that predate
    numbering, and those fall back to the id the API still resolves — an ugly
    URL beats a link that goes nowhere.
  */
  const key = onu.number ?? onu.id ?? onu.deviceId ?? '';
  return `/onus/${encodeURIComponent(String(key))}`;
}
